import React from 'react'
import { Typography, Icon, Button } from '@telavita-core/react-design-kit'

import { Reservation } from '../../'

import * as S from './styles'
import { format } from 'date-fns'

interface SuccessReservationProps {
  reservation: Reservation
  onCloseModal: () => void
  patientName: string
  exceptions?: { startDate: string, endDate: string }[]
}

export function SuccessReservation({
  reservation,
  onCloseModal,
  patientName,
  exceptions,
}: SuccessReservationProps): JSX.Element {
  return (
    <S.SuccessReservationContainer>
      
      <Icon
        name='Check'
        color='success'
        height={50}
        width={50}
      />
      
      <Typography
        variant='header4'
        center
      >
        Reserva efetuada com sucesso
      </Typography>
    
      <S.SuccessMessageTime>
        <Typography color='success' weight='bold'>
          {reservation.weekdayPlural}
        </Typography>
        <Typography color='success' weight='bold'>
          às {reservation.hour}
        </Typography>
      </S.SuccessMessageTime>

      {exceptions?.length > 0
        ? (
          <div>
            <Typography variant='content2' center weight='bold'>Exceto em:</Typography>

            {exceptions?.map((date, index) => {
              return (
                <Typography variant='content2' key={index}>
                  <strong>{format(new Date(date.startDate), 'dd/MM/yyyy')}</strong>, 
                  reservado para <strong>{format(new Date(date.startDate), 'HH:mm')}</strong>
                </Typography>
              )
            })}
          </div>
        ) 
        : null
      }

      <S.Box>

        <Typography
          weight='bolder'
          variant='content2'
        >
          INFORME AO PACIENTE:
        </Typography>

        <Typography
          variant='content2'
        >
          <b>1)</b>
          {' '}{patientName || 'Paciente'}, você deve continuar agendando suas consultas normalmente. A diferença é que, a partir de agora, este dia e horário vão aparecer
          <b>{' '} somente pra você</b> ao agendar.
        </Typography>

        <Typography
          variant='content2'
        >
          <b>{'2) '}</b>A confirmação da reserva será enviada por e-mail com todos os detalhes.
        </Typography>

      </S.Box>

      <Button
        variant='contained'
        uppercase={false}
        onClick={onCloseModal}
      >
        Fechar
      </Button>

    </S.SuccessReservationContainer>
  )
}